type NavItemColor = "Grey" | "Red" | undefined;

export const colorClass = (color: NavItemColor) =>
  color === "Red"
    ? "text-primary hover:text-primary! focus:text-primary! data-[active=true]:text-primary!"
    : "text-foreground";

export const newTabProps = (isNewTab?: boolean) =>
  isNewTab ? ({ target: "_blank", rel: "noopener noreferrer" } as const) : {};
